import { render, staticRenderFns } from "./pkgSelect.vue?vue&type=template&id=6522287d&scoped=true&"
import script from "./pkgSelect.vue?vue&type=script&lang=js&"
export * from "./pkgSelect.vue?vue&type=script&lang=js&"
import style0 from "./pkgSelect.vue?vue&type=style&index=0&id=6522287d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6522287d",
  null
  
)

export default component.exports